export const isRoleMatch = function (roleToCheck: string, requiredRole: string) {
  return roleToCheck === requiredRole;
}
